export default __webpack_public_path__ + "static/media/partner-01.44506479.webp";